import { Button, Label, StringUtils, TextField } from '@localina/core';
import { LockIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useResetPasswordMutation } from '../../../api/queries/auth';
import { PasswordToggle } from '../../../components';

interface IProps {
    code: string;
    onNext: () => void;
    onLogin: () => void;
    resetPasswordMutation: ReturnType<typeof useResetPasswordMutation>;
}

const DefinePassword: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const [password, setPassword] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [isFormValid, setFormValid] = React.useState(false);

    React.useEffect(() => {
        setFormValid(StringUtils.isValidPassword(password));
    }, [password]);

    const handleClick = () => {
        props.resetPasswordMutation.mutate(
            { code: props.code, password },
            {
                onSuccess: props.onNext,
            },
        );
    };

    const handleLogin = () => {
        props.onLogin();
    };

    return (
        <>
            <TextField
                label={t('resetPassword.fields.password')}
                name="password"
                autoComplete="new-password"
                type={showPassword ? 'text' : 'password'}
                shrink
                startAdornment={<LockIcon />}
                endAdornment={<PasswordToggle visible={showPassword} onToggle={() => setShowPassword(!showPassword)} />}
                required={true}
                value={password}
                onChange={setPassword}
            />
            {props.resetPasswordMutation.isError && <Label type="text" value={t('resetPassword.error')} error={true} />}
            <div className="buttons">
                <Button label={t('resetPassword.buttons.login')} secondary={true} onClick={handleLogin} />
                <Button label={t('resetPassword.buttons.confirm')} disabled={!isFormValid} onClick={handleClick} />
            </div>
        </>
    );
};
export default DefinePassword;
